<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: 'App',
  created() {
    if (localStorage.getItem('token')) {
      this.$store.dispatch('user/getMe');
    }
  },
};
</script>

<style lang="scss">
.ibox {
  border: 1px solid #e9e9e9;
  box-shadow: 1px 1px 7px 0 #ddd;
}
</style>



// WEBPACK FOOTER //
// App.vue?69f60290